module.exports=function(scope){ return `<!-- enrollmentIdentifier found in database -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "A FaceMap was found for that enrollmentIdentifier."
    },
    "data": {
        "enrollmentIdentifier": "foo",
        "createDate": "2017-01-01T00:00:00+00:00",
        "auditTrailImage": "...",
        "faceMap": "...",
        "faceMapType": 0
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/enrollment-get-facemap.json.tpl